'use client';

import { useRouter } from 'next/compat/router';
import { useMemo } from 'react';
import { useClubContext } from '~/components/ClubContext';

const extractSlugFromPath = (path?: string | null): string | undefined => {
    if (!path) return undefined;

    const pathname = path.split('?')[0]?.split('#')[0] ?? '';
    const segments = pathname.split('/').filter(Boolean);

    if (segments.length === 0) return undefined;

    if ((segments[0] === 'club' || segments[0] === 'invoices' || segments[0] === 'iframe') && segments[1]) {
        return decodeURIComponent(segments[1]);
    }

    return undefined;
};

export const useClubSlug = (slug?: string): string => {
    const clubSlug = useClubContext();
    const router = useRouter();

    const parsedSlug = useMemo(() => {
        if (slug) return slug;
        if (clubSlug) return clubSlug;

        const querySlug = router?.query?.slug;
        if (typeof querySlug === 'string' && querySlug.length > 0) return querySlug;
        if (Array.isArray(querySlug) && querySlug[0]) return querySlug[0];

        const routerPathSlug = extractSlugFromPath(router?.asPath);
        if (routerPathSlug) return routerPathSlug;

        if (typeof window !== 'undefined') {
            return extractSlugFromPath(window.location.pathname + window.location.search);
        }

        return undefined;
    }, [clubSlug, router?.asPath, router?.query?.slug, slug]);

    return parsedSlug;
};
